import React from 'react';
import { FaCamera } from 'react-icons/fa';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export const AccountLogoComponent = ({selectedBrand, logoIndex, openConfirmationLogo, getIsLogoRecordDeletable, selectedLogo, changeLogoImage, faviconSize, onFormLogoItemChange, logoBackground, handleOpen, deleteselectedLogo, handleClose, itemIndex }: any) => {

  return (
    <>
  <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>
      
              <div className=' py-4'>
              <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <div>
          <InputLabelContainer label="Pictures"/>
          <img
              src={selectedLogo?.Url}
              className="w-12 h-12"
          />

      <div
          onClick={() => changeLogoImage(
            logoIndex,
            'Url',
            'image',
            selectedBrand,
            itemIndex
          )}
      >
            <FaCamera  className=' text-2xl text-skin-ouprimary'/>
        </div>

     </div>
      
              <InputContainer
                  label="Size"
                 
                  onValueChange={(event: any, newValue: any) => {
                    onFormLogoItemChange({
                      value: event.target.value,
                      field: 'Size',
                      idx: logoIndex,
                      cardValue: selectedBrand,
                      idx1: itemIndex
                    });
                  }}
                  type="text"
                  value={selectedLogo?.Size}
                 
              />
            <InputContainer
                  label="Background"
                  labelField="Description"
                  list={logoBackground}
                  onValueChange={(event: any, newValue: any) => {
                    onFormLogoItemChange({
                      value: event.target.value,
                      field: 'Background',
                      idx: logoIndex,
                      cardValue: selectedBrand,
                      idx1: itemIndex
                    });
                  }}
                  optionName='Choose Background'
                  type="select"
                  value={selectedLogo?.Background}
                  valueField="Description"
              />
           
           
          </div>
          </div>
          
                </div>
    </>
  )
}
export default AccountLogoComponent;
